/**
 * Dates on sheet 43 (mission 10 WP16; FR-017; style guide §6, §9): every date is `format.date` in UTC inside
 * a `<time datetime>`, and the page states the UTC note once (`retentionTimezoneNote`, DataRetention.tsx).
 */
import { date, isoDateTime } from '@/lib/format'

/** One UTC date in a `<time datetime>`; mono in tables (§7.7, §11). */
export function UtcDate({ iso, mono = false }: { iso: string; mono?: boolean }) {
  return (
    <time dateTime={isoDateTime(iso)} className={mono ? 'font-mono' : undefined}>
      {date(iso)}
    </time>
  )
}

/** A register sentence holding `date(iso)`, with that date as a `<time datetime>`. */
export function WithDate({ text, iso }: { text: string; iso: string }) {
  const shown = date(iso)
  const at = text.indexOf(shown)
  if (at < 0) return <>{text}</>
  return (
    <>
      {text.slice(0, at)}
      <UtcDate iso={iso} />
      {text.slice(at + shown.length)}
    </>
  )
}
